
export enum NullableTipoFotoPesquisaFormsEnum {
  PesquisaPreco = 'PesquisaPreco',
}
